import "./css/footer.css"
import { Link } from "react-router-dom"
import linkname from "./linkname.jsx";

const Footer = () => {
    const currentYear = new Date().getFullYear();

    const Top = () => {
        window.scrollTo({
            top: 0,
            left: 0,
            behavior: 'smooth'
        });
    }

    return (
        <footer className="footerContainer">
            <div className="footerMainContainer">
                <div className="footerContentWrapper">

                    {/* Company Info */}
                    <div className="footerSection companyInfoSection">
                        <div className="footerLogo">
                            <h3 className="footerBrand">{process.env.REACT_APP_APP_NAME}</h3>
                            <p className="footerTagline">Your Path to Success Starts Here</p>
                        </div>
                        <p className="footerDescription">
                            Comprehensive platform for exam preparation with mock tests, previous year papers,
                            and subject-wise practice for government jobs and college entrance exams.
                        </p>
                    </div>

                    {/* Quick Links */}
                    <div className="footerSection">
                        <h4 className="footerSectionTitle">Quick Links</h4>
                        <div className="footerLinksGrid">
                            <Link to="/footer/features" className="footerLink" onClick={Top}>
                                <span>{linkname.features}</span>
                            </Link>
                            <Link to="/footer/about" className="footerLink" onClick={Top}>
                                <span>{linkname.about}</span>
                            </Link>
                            <Link to="/footer/contact" className="footerLink" onClick={Top}>
                                <span>{linkname.contact}</span>
                            </Link>
                            <Link to="/footer/help" className="footerLink" onClick={Top}>
                                <span>{linkname.helpcenter}</span>
                            </Link>
                            <Link to="/footer/guide" className="footerLink" onClick={Top}>
                                <span>{linkname.guide}</span>
                            </Link>
                            <Link to="/footer/manual" className="footerLink" onClick={Top}>
                                <span>{linkname.manual}</span>
                            </Link>
                        </div>
                    </div>

                    {/* Resources */}
                    <div className="footerSection">
                        <h4 className="footerSectionTitle">Resources</h4>
                        <div className="footerLinksGrid">
                            <Link to="/footer/policy" className="footerLink" onClick={Top}>
                                <span>{linkname.policy}</span>
                            </Link>
                            <Link to="/footer/conditions" className="footerLink" onClick={Top}>
                                <span>{linkname.conditions}</span>
                            </Link>
                            <Link to="/footer/guidelines" className="footerLink" onClick={Top}>
                                <span>{linkname.guidelines}</span>
                            </Link>
                            <Link to="/footer/cookies" className="footerLink" onClick={Top}>
                            {linkname.cookies}
                        </Link>
                            
                        </div>
                    </div>

                    {/* Contact & Social */}
                    <div className="footerSection">
                        <h4 className="footerSectionTitle">Connect With Us</h4>

                        <div className="contactInfo">
                            <div className="contactItem">
                                <i className="fas fa-envelope"></i>
                                <a href={`mailto:${process.env.REACT_APP_APP_EMAIL}`} className="contactLink">
                                    {process.env.REACT_APP_APP_EMAIL}
                                </a>
                            </div>
                            <div className="contactItem">
                                <i className="fas fa-phone"></i>
                                <a href={`tel:${process.env.REACT_APP_APP_CONTACT}`} className="contactLink">
                                    {process.env.REACT_APP_APP_CONTACT}
                                </a>
                            </div>
                        </div>

                        <div className="socialLinks">
                            <a href="https://www.instagram.com/examhall_05/" target="_blank" rel="noopener noreferrer" className="socialLink">
                                <i className="fab fa-instagram"></i>
                            </a>
                            <a href="https://www.facebook.com/profile.php?id=61575065221914" target="_blank" rel="noopener noreferrer" className="socialLink">
                                <i className="fab fa-facebook-f"></i>
                            </a>
                            <a href="https://www.youtube.com/channel/UCQ2oXyDnMyc97rSSEbpaBXg" target="_blank" rel="noopener noreferrer" className="socialLink">
                                <i className="fab fa-youtube"></i>
                            </a>
                            <a href="https://api.whatsapp.com/send?phone=916387139149" target="_blank" rel="noopener noreferrer" className="socialLink">
                                <i className="fab fa-whatsapp"></i>
                            </a>
                            <a href="https://t.me/ashu_233" target="_blank" rel="noopener noreferrer" className="socialLink">
                                <i className="fab fa-telegram"></i>
                            </a>
                        </div>
                    </div>

                </div>
            </div>

            <div className="footerBottomContainer">
                <div className="footerBottomContent">
                    <p className="copyright">
                        © {currentYear} {process.env.REACT_APP_APP_NAME}. All rights reserved.
                    </p>
                    <div className="footerBottomLinks">
                        <Link to="/footer/policy" className="bottomLink">Privacy Policy</Link>
                        <span className="separator">•</span>
                        <Link to="/footer/conditions" className="bottomLink">Terms of Service</Link>
                    </div>
                </div>
            </div>
        </footer>
    )
}

export default Footer